import React from 'react';

type Props = {
  compact?: boolean;
  className?: string;
};

/** Simple inline separator for car routes (distinct from flight arc). */
export const CarRouteSep: React.FC<Props> = ({ compact = false, className = '' }) => (
  <span
    className={`shrink-0 font-medium text-stone-400 dark:text-slate-500 ${compact ? 'text-xs' : 'text-sm'} ${className}`}
    aria-hidden
  >
    →
  </span>
);
